<template>
  <div>
    <v-snackbar v-model="snackbar" color="success" top>
      {{ "alerts_business_updated" | localize }}
    </v-snackbar>
    <VRow
      class="mt-10 mx-4"
      v-if="!editBusiness && $vuetify.breakpoint.smAndDown"
    >
      <v-progress-linear
        height="17"
        style="border-radius: 20px"
        color="#73AFE7"
        value="85"
      ></v-progress-linear>
    </VRow>
    <v-card-title v-if="!editBusiness">
      {{ "create_business_discount_settings" | localize }}
    </v-card-title>
    <v-card-text class="mt-3 payment">
      <VRow class="mb-5 align-center discount">
        <VCol class="py-0 col-md-5 col-sm-12 col-xs-12 label">
          {{ "discount_instructions_text" | localize }}:
          <span style="color: red">*</span>
        </VCol>
        <VCol class="col-12 col-md-7" v-if="!$vuetify.breakpoint.smAndDown">
          <v-select
            dense
            outlined
            color="rgb(218, 218, 218)"
            item-color="#72AFE7"
            hide-details
            :items="Object.values(products)"
            :item-value="'value'"
            :item-text="'name'"
            :menu-props="{ bottom: true, offsetY: true }"
            v-model="product"
            label=""
            :disabled="
              loggedUser.role_id === '0' || loggedUser.role_id === '1'
                ? false
                : true
            "
          ></v-select>
        </VCol>
        <VCol v-else class="col-12 pb-0">
          <VRow justify="start" no-gutters>
            <v-chip-group
              active-class="chips-select active"
              column
              :disabled="
                loggedUser.role_id === '0' || loggedUser.role_id === '1'
                  ? false
                  : true
              "
              v-model="product"
              row
              mandatory
            >
              <v-chip
                class="chips-select"
                v-for="product in products"
                :key="product.value"
                :value="product.value"
              >
                {{ product.name }}
              </v-chip>
            </v-chip-group>
          </VRow>
        </VCol>
      </VRow>
      <VRow class="align-center hoozies">
        <VCol class="col-md-5 col-sm-12 col-xs-12 label py-0"
          ><span>{{ "discounted_by" | localize }}</span>
          <span style="color: red">*</span></VCol
        >
        <VCol class="col-12 col-md-7">
          <v-select
            :disabled="
              loggedUser.role_id === '0' || loggedUser.role_id === '1'
                ? false
                : true
            "
            dense
            outlined
            color="rgb(218, 218, 218)"
            item-color="#72AFE7"
            hide-details
            v-model="hoozies"
            :menu-props="{ bottom: true, offsetY: true }"
            :items="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100]"
          >
            <template v-slot:item="{ item }">
              <div class="text-body-2">{{ item }}%</div>
            </template>
            <template v-slot:selection="{ item }">
              <div>{{ item }}%</div>
            </template></v-select
          >
        </VCol>
      </VRow>
    </v-card-text>
    <v-card-actions>
      <div v-if="!$vuetify.breakpoint.smAndDown" style="width: 100%">
        <VRow class="mb-5 mt-5" v-if="!editBusiness" no-gutters>
          <div class="ml-auto">
            <v-btn
              block
              outlined
              color="#72AFE7"
              v-on:click="$emit('previous')"
              >{{ "add_business_prev" | localize }}</v-btn
            >
          </div>
          <div class="ml-2 d-flex">
            <v-btn
              class="next-pay white--text"
              color="#72AFE7"
              :loading="isLoading"
              v-on:click="next()"
              >{{ "add_business_next" | localize }}</v-btn
            >
          </div>
        </VRow>

        <div
          class="ml-auto d-flex"
          v-if="
            (editBusiness && loggedUser.role_id === '0') ||
            loggedUser.role_id === '1'
          "
        >
          <v-btn
            v-if="!$vuetify.breakpoint.xs"
            class="white--text"
            color="#72AFE7"
            :loading="updateLoading"
            v-on:click="update()"
            >{{ "add_business_update" | localize }}</v-btn
          >
        </div>
      </div>
      <VRow
        align="center"
        justify="center"
        class="mx-auto"
        v-if="$vuetify.breakpoint.smAndDown && !editBusiness"
      >
        <VCol>
          <v-btn
          :loading="isLoading"
            block
            class="next-pay white--text"
            style="
              text-transform: none;
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            "
            color="#72AFE7"
            v-on:click="next()"
            >{{ "add_business_next" | localize }}</v-btn
          >
          <v-btn
            block
            class="mt-3"
            style="text-transform: none"
            color="#72AFE7"
            text
            v-on:click="$emit('previous')"
            >{{ "add_business_prev" | localize }}</v-btn
          >
        </VCol>
      </VRow>
    </v-card-actions>
  </div>
</template>

<script>
import BusinessService from "@/requests/Business/BusinessService";
import requestFormData from "@/requests/requestFormData";
import { mapGetters } from "vuex";
import Shepherd from "shepherd.js";
import en from "@/locales/en.json";
import es from "@/locales/es.json";

const tour = new Shepherd.Tour({
  useModalOverlay: true,
  defaultStepOptions: {
    cancelIcon: {
      enabled: true,
    },
    scrollTo: { block: "center" },
  },
  popperOptions: {
    modifiers: [{ name: "offset", options: { offset: [0, 100] } }],
  },
});

tour.on("cancel", () => {
  localStorage.tutorialStep = tour.getCurrentStep().id;
});

export default {
  props: {
    editBusiness: {
      type: Object,
      require: false,
    },
    updates: {
      require: false,
    },
  },
  data: () => ({
    products: [],
    hoozies: 5,
    lang: null,
    snackbar: false,
    isLoading: false,
    product: "All",
    updateLoading: false,
  }),
  destroyed() {
    this.resetSteps();
  },
  mounted() {
    this.updateStepsText();
    if (this.loggedUser.locale === "en") {
      this.products.push(
        {
          name: "all",
          value: "All",
        },
        {
          name: "some",
          value: "Selected",
        }
      );
    } else {
      this.products.push(
        {
          name: "todos",
          value: "All",
        },
        {
          name: "algunos",
          value: "Selected",
        }
      );
    }
    if (this.editBusiness) {
      this.getPayment();
    } else {
      //this.product = this.products[0];
    }
  },
  computed: {
    ...mapGetters(["loggedUser"]),
  },
  methods: {
    updateStepsText() {
      if (this.loggedUser.locale === "en") {
        this.lang = en;
      } else {
        this.lang = es;
      }
    },
    resetSteps() {
      tour.removeStep("payment");
      tour.removeStep("discount");
      tour.removeStep("hoozies");
      tour.removeStep("nextPayment");
      tour.complete();
    },
    next() {
      tour.complete();
      this.isLoading = true;
      this.$emit("addedPayment", this.product, this.hoozies);
    },
    getPayment() {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].value == this.editBusiness.discount_type) {
          this.product = this.products[i].value;
        }
      }
      this.hoozies = parseInt(this.editBusiness.discount_amount_min);
    },
    update() {
      this.updateLoading = true
      let subcategories = [];
      if (this.editBusiness.categories.length > 1) {
        for (
          let i = 0;
          i < this.editBusiness.categories[1].subcategory.length;
          i++
        ) {
          subcategories.push({
            category_id: parseInt(this.editBusiness.categories[1].id),
            subcategory_id: this.editBusiness.categories[1].subcategory[i].id,
          });
        }
      } else {
        [{ ...this.editBusiness.categories }].forEach((category) =>
          subcategories.push({ category_id: Object.keys(category)[0] })
        );
      }
      var form = new FormData();
      form.append("type", parseInt(this.editBusiness.type_id));
      form.append("shop_name", this.editBusiness.shop_name);
      form.append("shop_logo", this.editBusiness.shop_logo);
      form.append("shop_description", this.editBusiness.shop_description);
      form.append("shop_email", this.editBusiness.shop_email);
      form.append("phone_code", this.editBusiness.phone_code);
      form.append("phone_number", this.editBusiness.phone_number);
      form.append("shop_website", this.editBusiness.shop_website);
      form.append("address", this.editBusiness.address);
      form.append("geo_lat", parseFloat(this.editBusiness.geo_lat));
      form.append("geo_lon", parseFloat(this.editBusiness.geo_lon));
      form.append("neighbourhood", parseInt(this.editBusiness.neighbourhood));
      form.append("device_access", parseInt(this.editBusiness.device_access));
      form.append("internet", this.editBusiness.internet);
      form.append("size", parseInt(this.editBusiness.size));
      form.append("canaco_id", this.editBusiness.canaco_id);
      form.append("discount_amount_min", this.hoozies);
      form.append("discount_amount_max", this.hoozies);
      form.append("discount_type", this.product);
      form.append("working_days", this.editBusiness.shop_working_days);
      form.append("working_hours", this.editBusiness.working_hours);
      form.append("city_id", this.editBusiness.city_id);
      form.append("municipality", this.editBusiness.municipality);
      var object = {};
      form.forEach(function (value, key) {
        object[key] = value;
      });
      object["working_days"] = this.editBusiness.shop_working_days;
      object["working_hours"] = this.editBusiness.working_hours;
      object["category"] = subcategories;

      let formParsed = requestFormData.jsonToFormData(object);
      BusinessService.updateBusiness(this.$route.params.bid, formParsed).then(
        () => {
          this.snackbar = true;
          this.$emit("updated");
          this.updateLoading = false;
        }
      );
    },
    nextTutorial() {
      let that = this;
      tour.addStep({
        id: "payment",
        text: that.lang["tour-create-business-enter-discount"],
        attachTo: {
          element: ".payment",
          on: "top",
        },
        buttons: [
          {
            text: that.lang["tour-previous-step"],
            action() {
              tour.complete();
              that.$emit("toLastStep");
            },
            classes: "shepferd-theme-prev-btn",
          },
          {
            text: that.lang["tour-next-step"],
            action: tour.next,
            classes: "shepferd-theme-next-btn",
          },
        ],
      });
      tour.addStep({
        id: "discount",
        text: that.lang["tour-create-business-discount"],
        attachTo: {
          element: ".discount",
          on: "top",
        },
        buttons: [
          {
            text: that.lang["tour-previous-step"],
            action: tour.back,
            classes: "shepferd-theme-prev-btn",
          },
          {
            text: that.lang["tour-next-step"],
            action: tour.next,
            classes: "shepferd-theme-next-btn",
          },
        ],
      });
      tour.addStep({
        id: "hoozies",
        text: that.lang["tour-create-business-discount-value"],
        attachTo: {
          element: ".hoozies",
          on: "top",
        },
        buttons: [
          {
            text: that.lang["tour-previous-step"],
            action: tour.back,
            classes: "shepferd-theme-prev-btn",
          },
          {
            text: that.lang["tour-next-step"],
            action: tour.next,
            classes: "shepferd-theme-next-btn",
          },
        ],
      });
      tour.addStep({
        id: "nextPayment",
        text: that.lang["tour-create-business-finish"],
        attachTo: {
          element: ".next-pay",
          on: "top",
        },
        buttons: [
          {
            text: that.lang["tour-previous-step"],
            action: tour.back,
            classes: "shepferd-theme-prev-btn",
          },
        ],
      });
      tour.start();
      if (tour.isActive()) {
        let tutorialStep = localStorage.tutorialStep;
        if (
          tutorialStep == "payment" ||
          tutorialStep == "discount" ||
          tutorialStep == "hoozies" ||
          tutorialStep == "nextPayment"
        ) {
          tour.hide();
          tour.show(localStorage.tutorialStep);
        }
      }
    },
  },
  watch: {
    updates: {
      deep: true,
      handler() {
        this.update();
      },
    },
    product: {
      handler(){
        if (this.editBusiness && this.$vuetify.breakpoint.smAndDown) {
          let business = {}
          business.discount_type = this.product

          this.$emit('changed_business', business)
        }
      }
    },
    hoozies: {
      handler(){
        if (this.editBusiness && this.$vuetify.breakpoint.smAndDown) {
          let business = {}
          business.discount_amount_max = this.hoozies
          business.discount_amount_min = this.hoozies

          this.$emit('changed_business', business)
        }
      }
    },
    loggedUser: {
      deep: true,
      handler() {
        this.updateStepsText();
        if (this.loggedUser.locale === "en") {
          this.products = [
            {
              name: "all",
              value: "All",
            },
            {
              name: "some",
              value: "Selected",
            },
          ];
        } else {
          this.products = [
            {
              name: "todos",
              value: "All",
            },
            {
              name: "algunos",
              value: "Selected",
            },
          ];
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.label {
  font-size: 16px;
  min-height: 8px;
  font-weight: 600;
}

.chips-select {
  font-size: 10.5px;
  background-color: #ffffff !important;
  color: #3a3a3a !important;
  border: 1px solid #b9b9b9 !important;
  height: 25px;
  width: 65px !important;
  justify-content: center;
  &.active {
    background-color: #73afe7 !important;
    color: #ffffff !important;
    box-shadow: 0px 2.82353px 2.82353px rgba(0, 0, 0, 0.25);
  }
}
</style>